import Avatar from "components/SharedComponents/Avatar";
import { useTheme } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";
import { IDarkTheme } from "styles/darkTheme";

export interface ITestimonialCard {
  userImg: any;
  userName: string;
  userRole: string;
  userPost: string;
  withQuote?: boolean;
}

const TestmonialCard = ({
  userImg,
  userName,
  userPost,
  userRole,
  withQuote
}: ITestimonialCard) => {
  const theme = useTheme<IDarkTheme>();
  return (
    <Stack
      gap={"16px"}
      sx={{
        backgroundColor: theme.colors.semantic.semantic_white,
        borderRadius: "12px",
        maxWidth: "min(400px,84vw)",
        padding: "16px",
        position: "relative"
      }}
    >
      {withQuote && (
        <p
          style={{
            position: "absolute",
            fontSize: "200px",
            left: "80%",
            top: "-72px",
            color: theme.colors.neutrals.neutrals_20
          }}
        >
          “
        </p>
      )}
      <Stack direction={"row"} gap={"8px"}>
        <Avatar src={userImg} />
        <Stack alignSelf={"center"}>
          <p
            style={{
              fontSize: theme.fontSize.bodyText_1,
              color: theme.colors.neutrals.neutrals_100,
              fontWeight: theme.fontWeight.big
            }}
          >
            {userName}
          </p>
          <p
            style={{
              fontSize: theme.fontSize.bodyText_2,
              color: theme.colors.neutrals.neutrals_80,
              fontWeight: theme.fontWeight.normal
            }}
          >
            {userRole}
          </p>
        </Stack>
      </Stack>
      <p
        style={{
          fontWeight: theme.fontWeight.medium,
          fontSize: theme.fontSize.bodyText_1
        }}
      >
        {userPost}
      </p>
    </Stack>
  );
};

export default TestmonialCard;
